import type { OpeningTimes } from '~/types/OpeningTimes'
import { getOpeningTimesForCurrentDay } from './getOpeningTimesForCurrentDay'
import { nowIsWithinOpeningTimes } from './nowIsWithinOpeningTimes'
import { serviceIsOpenNow } from './serviceIsOpenNow'

export const serviceClosesAt = (openingTimes: OpeningTimes) => {
  const openingTimesForCurrentDay = getOpeningTimesForCurrentDay(openingTimes)
  const openingHoursForCurrentDay = openingTimesForCurrentDay.openingHours

  // check if it's open
  const isOpen = serviceIsOpenNow(openingTimes)

  // if it's not open, it's already closed, so no closesAt time
  if (!isOpen) return null

  // otherwise, find the closesAt time closest to now
  const openingTimesThatAreNow = openingHoursForCurrentDay.filter((openingHour) =>
    nowIsWithinOpeningTimes(openingHour)
  )
  const firstOpeningTimeThatIsNow = openingTimesThatAreNow[0]
  if (!firstOpeningTimeThatIsNow) return null

  return firstOpeningTimeThatIsNow.endTime
}
